import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74b25223"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "acOnBoarding"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "acOnBoarding_overlay" }, null, -1))
const _hoisted_3 = { class: "acOnBoarding_content" }
const _hoisted_4 = { class: "acOnBoarding_progress" }
const _hoisted_5 = {
  class: "acOnBoarding_steps",
  ref: "refStepsContainer"
}
const _hoisted_6 = {
  class: "acOnBoarding_wrapper",
  ref: "refStepsWrapper"
}
const _hoisted_7 = { class: "acOnBoarding_actions" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_2160_7930)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10.828 12.0007L15.071 16.2437C15.4615 16.6342 15.4615 17.2673 15.071 17.6577C14.6805 18.0482 14.0475 18.0482 13.657 17.6577L8.48954 12.4903C8.21917 12.2199 8.21917 11.7815 8.48954 11.5112L13.657 6.34372C14.0475 5.95325 14.6805 5.95325 15.071 6.34372C15.4615 6.73418 15.4615 7.36725 15.071 7.75772L10.828 12.0007Z",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2160_7930" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "24",
        height: "24",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "17",
  height: "30",
  viewBox: "0 0 17 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.0203 14.6464C0.82504 14.8417 0.825039 15.1583 1.0203 15.3536L15.3132 29.6464C15.6282 29.9614 16.1667 29.7383 16.1667 29.2929V0.707107C16.1667 0.261655 15.6282 0.0385709 15.3132 0.353553L1.0203 14.6464Z",
    fill: "white"
  })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "17",
  height: "30",
  viewBox: "0 0 17 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.9797 14.6464C16.175 14.8417 16.175 15.1583 15.9797 15.3536L1.68681 29.6464C1.37182 29.9614 0.833252 29.7383 0.833252 29.2929V0.707107C0.833252 0.261655 1.37182 0.0385709 1.68681 0.353553L15.9797 14.6464Z",
    fill: "white"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_progress = _resolveComponent("ac-progress")!
  const _component_ac_button = _resolveComponent("ac-button")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#modals" }, [
    (_ctx.showOnBoarding)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (value, key) => {
                return (_openBlock(), _createBlock(_component_ac_progress, {
                  key: `progress-${key}`,
                  modelValue: _ctx.progress[key],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.progress[key]) = $event),
                  class: "acOnBoarding_progressBar",
                  "show-text": false
                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (value, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: key,
                    class: _normalizeClass(["acOnBoarding_step", `${key === _ctx.currentStep ? '-active' : ''} step-${key}`])
                  }, _toDisplayString(value.id), 3))
                }), 128))
              ], 512)
            ], 512),
            _createElementVNode("div", _hoisted_7, [
              (!_ctx.isDisabledPrevBtn)
                ? (_openBlock(), _createBlock(_component_ac_button, {
                    key: 0,
                    class: "acOnBoarding_action -prev -mobile",
                    disabled: _ctx.isDisabledPrevBtn,
                    onClick: _ctx.onPrevStep
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ac_button, {
                class: "acOnBoarding_action -next -mobile",
                onClick: _ctx.onNextStep,
                block: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('continue')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_ac_button, {
                class: "acOnBoarding_action -prev -desktop",
                icon: "",
                disabled: _ctx.isDisabledPrevBtn,
                onClick: _ctx.onPrevStep
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_ac_button, {
                class: "acOnBoarding_action -next -desktop",
                icon: "",
                onClick: _ctx.onNextStep
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}